import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';

export const UrlInput = (props: FieldExtensionComponentProps<string>) => {
  const { schema } = props;
  const { title, description } = schema;
  return (
    <FormControl
      variant="standard"
      margin="normal"
      required
      error={props.rawErrors?.length > 0}
    >
      <InputLabel htmlFor="validateUrl">{title}</InputLabel>
      <Input
        id="validateUrl"
        aria-describedby="urlInput"
        onChange={e => props.onChange(e.target?.value)}
      />
      <FormHelperText id="urlInput">{description}</FormHelperText>
    </FormControl>
  );
};
